import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useApplyLinkMutation } from "../services/apiSlice";

export const ApplyForJob = async (jobId, applyLink, isError, error) => {
  //   const navigate = useNavigate();
  console.log({ jobId });
  try {
    const responseData = await applyLink(jobId).unwrap();
    console.log(
      { responseData },
      "responseData?.message",
      responseData?.message
    );
    if (responseData?.success === true) {
      // success message
      Swal.fire("Awesome!", `  ${responseData?.message}`, "success").then(
        (result) => {
          if (result.isConfirmed || result.isDismissed) {
            // navigate(0);
          }
        }
      );
    } else if (isError) {
      //error
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    } else if (responseData?.success === false) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: responseData?.message,
      });
    } else if (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    } else {
      console.log("error", error?.data?.message);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: responseData?.message,
      });
    }
  } catch (error) {
    if (isError) {
      //error
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    } else {
      console.log("error", error?.data?.message, error?.message);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    }
  }
};
